import { render, staticRenderFns } from "./ProductUpdateComponent.vue?vue&type=template&id=522727d0&scoped=true"
import script from "./ProductUpdateComponent.vue?vue&type=script&lang=js"
export * from "./ProductUpdateComponent.vue?vue&type=script&lang=js"
import style0 from "./ProductUpdateComponent.vue?vue&type=style&index=0&id=522727d0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522727d0",
  null
  
)

export default component.exports